"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.valueSym = exports.typeSym = void 0;
exports.typeSym = Symbol('type');
exports.valueSym = Symbol('value');
//# sourceMappingURL=constants.js.map